const BillingCycle = {
	YEARLY: 'yearly',
	MONTHLY: 'monthly',
} as const;

export default BillingCycle;
